import React from "react";
import NavBar from "./nav-bar";
import Footer from "./footer";
import SessionNotice from "./session-notice";

const Layout = ({ children, location }) => {
  return (
    <>
      <NavBar location={location} />
      <div className="flex min-h-screen flex-col font-medium text-gray-900">
        <main id="fade-in-element" className="flex flex-grow flex-col bg-white">
          {children}
        </main>
      </div>
      <Footer />
      <SessionNotice />
    </>
  );
};

export default Layout;
